import moment from 'moment';


class WorkingTimings {
  constructor($scope, durationService) {
    this.durationService = durationService;
    this.formatter = this.durationService.getFormatter({ mode: 'hm' });
    this.converter = durationService.getConverter();
  }

  $onInit() {
    // default is true
    this.enableInherit = this.enableInherit === undefined || this.enableInherit;
  }

  $onChanges(changes) {
    if (changes.value && changes.value.currentValue) {
      this.duration = this.converter.fromMinutes(this.value.workingDayDuration);

      const now = moment().startOf('isoWeek');
      this.daysOfWeek = this.value.weekDayConfig.map((d) => {
        const day = now.day(d.weekDayIndex);
        return {
          value: d,
          label: day.format('dd'),
          weekday: day.weekday(),
        };
      });
      this.daysOfWeek.sort((a, b) => a.weekday - b.weekday);
    }
  }

  onDurationChange() {
    this.value.workingDayDuration = this.duration.invalid ? this.duration: this.converter.toMinutes(this.duration);
  }
}

WorkingTimings.$inject = ['$scope', 'durationService'];

export default WorkingTimings;



// WEBPACK FOOTER //
// ../widgets/working-timings/working-timings.controller.js